import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBank: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBank"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.38184L2 6.38184V9.99987H4V16H3.27995L1.61328 21H22.3881L20.7215 16H20V9.99987H22V6.38184L12 1.38184ZM18 9.99987H16V16H18V9.99987ZM14 16V9.99987H10V16H14ZM8 16V9.99987H6V16H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBank;
